module.exports = __webpack_public_path__ + "img/tutorial.b8a21465.png";